import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicePage from "@/pages/ServicePage";
import CalculatorsPage from "@/pages/CalculatorsPage";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import CookiePolicy from "@/pages/CookiePolicy";
import Complaints from "@/pages/Complaints";
import ReferralTerms from "@/pages/ReferralTerms";
import HowItWorksPage from "@/pages/HowItWorksPage";
import JargonBuster from "@/pages/JargonBuster";
import Guides from "@/pages/Guides";
import ReferFriend from "@/pages/ReferFriend";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollManager />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/mortgages/:slug" element={<ServicePage />} />
            <Route path="/calculators" element={<CalculatorsPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/complaints" element={<Complaints />} />
            <Route path="/referral-terms" element={<ReferralTerms />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/resources/jargon-buster" element={<JargonBuster />} />
            <Route path="/resources/guides" element={<Guides />} />
            <Route path="/resources/refer-a-friend" element={<ReferFriend />} />
            <Route path="*" element={<ServicePage />} />
          </Routes>
          <Footer />
          <CookieBanner />
          <FloatingWhatsApp />
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
